import React, { useState, useEffect, useRef } from 'react';
import AddIcon from '@mui/icons-material/Add';

const CustomsAutocomplete = ({ 
  value, 
  onChange, 
  options, 
  label, 
  onAddNew,
  placeholder = "Gümrük ara..."
}) => {
  const [inputValue, setInputValue] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [filteredOptions, setFilteredOptions] = useState([]);
  const wrapperRef = useRef(null);
  
  // Initialize the input value based on the selected value
  useEffect(() => {
    if (value) {
      const selectedOption = options.find(option => option.id === value);
      if (selectedOption) {
        setInputValue(`${selectedOption.customs_name} - ${selectedOption.city}, ${selectedOption.country}`);
      } else {
        setInputValue('');
      }
    } else {
      setInputValue('');
    }
  }, [value, options]);

  // Filter options based on input value
  useEffect(() => {
    if (!inputValue) {
      setFilteredOptions(options);
    } else {
      const filtered = options.filter(option => 
        option.customs_name.toLowerCase().includes(inputValue.toLowerCase()) ||
        option.city.toLowerCase().includes(inputValue.toLowerCase()) ||
        option.country.toLowerCase().includes(inputValue.toLowerCase()) ||
        option.customs_code.toLowerCase().includes(inputValue.toLowerCase())
      );
      setFilteredOptions(filtered);
    }
  }, [inputValue, options]);

  // Handle click outside to close dropdown
  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
        
        // Reset input to selected value if clicked outside
        if (value) {
          const selectedOption = options.find(option => option.id === value);
          if (selectedOption) {
            setInputValue(`${selectedOption.customs_name} - ${selectedOption.city}, ${selectedOption.country}`);
          }
        }
      }
    }
    
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [value, options]);

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
    setIsOpen(true);
  };

  const handleOptionClick = (option) => {
    onChange(option.id);
    setInputValue(`${option.customs_name} - ${option.city}, ${option.country}`);
    setIsOpen(false);
  };

  const handleInputFocus = () => {
    setIsOpen(true);
  };

  return (
    <div className="relative" ref={wrapperRef}>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        {label}
      </label>
      <div className="flex space-x-2">
        <div className="relative flex-1">
          <input
            type="text"
            value={inputValue}
            onChange={handleInputChange}
            onFocus={handleInputFocus}
            placeholder={placeholder}
            autoComplete="new-password"
            className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          {isOpen && filteredOptions.length > 0 && (
            <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-auto">
              {filteredOptions.map((option) => (
                <div
                  key={option.id}
                  onClick={() => handleOptionClick(option)}
                  className="px-4 py-2 hover:bg-blue-50 cursor-pointer"
                >
                  <div className="font-medium">{option.customs_name}</div>
                  <div className="text-sm text-gray-500">
                    {option.customs_code} - {option.city}, {option.country}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
        <button
          type="button"
          onClick={onAddNew}
          className="px-3 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 flex items-center"
        >
          <AddIcon className="w-4 h-4 mr-1" />
          Gümrük Ekle
        </button>
      </div>
    </div>
  );
};

export default CustomsAutocomplete;
